import { getFirebaseAuth } from "./getFirebaseAuth";

export const getFirebaseUser = () => getFirebaseAuth().currentUser;
